import { swSettings } from "app/common/services/swSettings";

import { isChromeBrowser } from "./browserDetection";
import { isCCUserInTrial } from "./trialCheckUtils";
import { isAfterTrialCC, isSI, isTrialOrAfterTrial, isWebSolutionUser } from "./usersUtils";

export const isEligibleForExtensionPromotion = (): boolean => {
    const isTrialOrPostTrialUser =
        isTrialOrAfterTrial(swSettings) ||
        isCCUserInTrial(swSettings.user?.customData?.quiz?.CcTrialStartDate) ||
        isAfterTrialCC(swSettings);

    const isCorrectSolution = !isSI(swSettings) && isWebSolutionUser(swSettings);

    return isCorrectSolution && isTrialOrPostTrialUser && isChromeBrowser();
};
